import { useQuery } from "@tanstack/react-query";
import { authorizationService } from "../services/authorizationService";
import { PartnerType } from "@/app/utils/partners.enum";

export const useAuthorizationId = (id?: string, type?: PartnerType) => {
  return useQuery({
    queryKey: ["authorization", id],
    queryFn: () =>
      authorizationService.getAuthorizationId(id!, {
        type: type!,
      }),
    enabled: Boolean(id && type),
  });
};
